import { MainTitle, TextList } from '@repo/ui';

interface Props {
  handleAsk: () => void;
}

const ApplyResultNoticeSectionView = ({ handleAsk }: Props) => {
  const APPLY_RESULT_GIODELINE_DATA = [
    '경정청구란 세법에서 정한 금액보다 더 많은 세금을 납부했을 때 환급을 청구하는 절차로, 국세기본법에 명시된 국세청 권장 제도입니다.',
    '납세자의 권익 보호가 경정청구 제도의 취지이므로 환급으로 인한 세무조사는 없습니다.',
    '본 서비스는 일회성으로 세무대리 위임을 받고 있으며, 기존에 연결된 세무대리인은 변경되지 않습니다.',
    '세금환급을 위한 국세청 신고는 비즈넵 제휴 세무대리인이 진행하며, 비즈넵은 세무대리 업무를 수행하지 않습니다.',
    '주민등록번호 등의 개인정보의 수집 및 이용 주체는 세무대리인이며, 비즈넵은 세무대리인으로부터 업무위탁을 받아 안전하게 보관하고 있습니다.',
    '체납중이거나, 납기중인 세금이 있는 경우 국세청에서 자동으로 충당처리 됩니다.',
    '당사 경정청구 신고서 접수 후 타사 중복 접수로 인한 불이익은 고객의 과실이므로 당사에 책임을 물을 수 없으며, 이미 진행된 제휴 세무사 업무에 대한 비용 청구에 이의를 제기할 수 없습니다.'
  ];

  return (
    <div className="page-padding bg-gray-50 pb-2 pt-5">
      <MainTitle className={'pt-normal-medium pb-normal-small'} title={'안내 및 주의사항'} size={'xsmall'} />
      {APPLY_RESULT_GIODELINE_DATA.map((text, idx) => (
        <TextList className={'text-neutral-foreground-low py-0.5'} key={idx} variant={'bullet'} size={'medium'}>
          {text}
        </TextList>
      ))}

      <div className="body-14 text-gray-800 pt-normal-large">
        <p className="mb-2 text-gray-700">추가로 궁금하신 점이 있으시면 고객센터로 문의해주세요.</p>
        <ul className="mb-5">
          <li className="mb-2">
            <div className="text-violet-600 cursor-pointer" onClick={handleAsk}>
              {'고객센터로 문의하기$>;'}
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ApplyResultNoticeSectionView;
